import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';
import debounce from 'lodash/debounce';
import {size} from 'lodash';
import {injectIntl} from "react-intl";

import {modifyPageLayoutComponents} from '../PageLayout';
import template from './Employees.rt';
// import EmployeesHeaderTemplate from './EmployeesHeader.rt';
import EmployeesHeader from './EmployeesHeader'
import {getEmployees, changeEmployeeStatus, expandEmployee, changeEmployeeAdminStatus} from './EmployeesActions';
import {showAssignEntityPopup} from '../../actions/A_Popups';
import {logout} from '../../actions';
import {assignEntitySavingStatus} from '../../selectors/popups';
import {AccessRights} from '../../schemas/accessRightsModel';
import * as actions from '../../actions';

const mapStateToProps = state => {
  const {employees} = state;
  const {auth} = state;
  const {asCustomer} = state;
  return {
    searchKeyword: employees.searchKeyword,
    employees: employees.data.rows,
    page: employees.data.page,
    totalPages: employees.data.totalPages,
    popupsStatusUpdateSuccess: assignEntitySavingStatus(state),
    statusUpdateSuccess: employees.statusUpdateSuccess,
    userRoles: state.auth.roles,
    expandedEmployeeId: employees.expandedEmployeeId,
    AR: AccessRights.get(state),
    auth,
    asCustomer
  };
};

const mapDispatchToProps = dispatch => ({
  getEmployees: (page, limit, searchKeyword) => dispatch(getEmployees(page, limit, searchKeyword)),
  changeEmployeeStatus: (userId, fabricatorId, enabled, isPrimaryProfile = false) => dispatch(changeEmployeeStatus(userId, fabricatorId, enabled, isPrimaryProfile)),
  setSearchTerm: (value) => dispatch(getEmployees(0, 50, value)),
  logout: () => dispatch(logout()),
  expandEmployee: (employeeId) => dispatch(expandEmployee(employeeId)),
  changeEmployeeAdminStatus: (userId, fabricatorId, enabled) => dispatch(changeEmployeeAdminStatus(userId, fabricatorId, enabled)),
  showAssignEntityPopup: config => dispatch(showAssignEntityPopup(config)),
  showAlert: (text) => dispatch(actions.messageBox_Show(true, 'error', 'Error processing request', text)),
});

class Employees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0,
      isDropDownOpened: false,
      activeUser: {},
      showFabricatorPopup: false,
      showStoresPopup: false,
      showPermissionsEmployeePopup: false,
      showPermissionsUserCustomerPopup: false,
      activeDropDownValue: 'Employees',
      dropdownValues: [
        'Fabricators',
        'Customers',
        'Stores'
      ]
    };

    this.debouncedGetEmployees = debounce(this.props.getEmployees, 250);
  }

  componentDidMount() {
    this.props.getEmployees();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statusUpdateSuccess) {
      this.props.getEmployees(this.state.page, 50, this.props.searchKeyword);
    }
  }

  handleActivateUser = (userId, fabricatorId, enabled, hasPassword) => {
    if(!hasPassword){
      this.props.showAlert("The user has not set a password yet.");
      return;
    }
    this.props.changeEmployeeStatus(userId, fabricatorId, !enabled);
  };

  handlePaginate = (page) => {
    this.setState({page: page - 1});
    this.props.getEmployees(page - 1, 50, this.props.searchKeyword);
  };

  handleSearch = (value) => {
    this.setState({searchKeyword: value}, () => {
      this.debouncedGetEmployees(0, 50, value);
    });
  };

  handleRedirect = (entityId, clientType, clientSubType) => {
    let redirectUrl = 'account';
    if (entityId) {
      redirectUrl += `?entityId=${entityId}&clientType=${clientType}`;
    }

    if (!entityId) {
      redirectUrl += `?clientType=${clientType}&clientSubType=${clientSubType}`;
    }

    hashHistory.push(redirectUrl)
  };

  handleDropDownChange = (value) => {
    this.setState({isDropDownOpened: !this.state.isDropDownOpened});

    if (value) {
      hashHistory.push(value.toLowerCase());
    }
  };

  handleShowPopup = (userId, fabricatorId, popupName) => {
    const {intl} = this.props;
    let activeUser = this.props.employees.find(emp => emp.id === userId);

    const newState = {
      activeUser: activeUser,
      fabricatorId
    };

    switch (popupName) {
      case "fabricators":
        this.props.showAssignEntityPopup({
          entityId: activeUser.id,
          entityType: 'employee',
          visible: true,
          entitiesType: 'fabricators',
          headerText: `${intl.formatMessage({id: "assignEntityPopup.addFabricatorsToEmployee"})}: ${activeUser.name}`,
          singleSelection: false
        });
        break;
      case "stores":
        this.props.showAssignEntityPopup({
          entityId: activeUser.id,
          entityType: 'employee',
          visible: true,
          entitiesType: 'stores',
          headerText: `${intl.formatMessage({id: "assignEntityPopup.addStoresToEmployee"})}: ${activeUser.name}`
        });
        break;
      case "permissionsEmployee":
        newState.showPermissionsEmployeePopup = !this.state.showPermissionsEmployeePopup;
        break;
      case "permissionsUserCustomer":
        newState.showPermissionsUserCustomerPopup = !this.state.showPermissionsUserCustomerPopup;
        break;
    }
    this.setState(newState);
  };

  handleClosePopup = (popupName) => {
    const newState = {};
    switch (popupName) {
      case "fabricators":
        newState.showFabricatorPopup = false;
        break;
      case "stores":
        newState.showStoresPopup = !this.state.showStoresPopup;
        break;
      case "permissionsemployee":
        newState.showPermissionsEmployeePopup = false;
        break;
      case "permissionsuserCustomer":
        newState.showPermissionsUserCustomerPopup = false;
        break;
    }
    this.setState(newState);
  };

  canSeePermissionsButtonForEntity = entity => {
    const {AR, auth, asCustomer} = this.props;
    let userId = auth.userId;
    let roles = auth.roles;
    if (asCustomer.activeEntity) {
      userId = asCustomer.activeEntity.id;
      roles = asCustomer.activeEntity.roles;
    }

    if (!size(roles))
      return false;

    if (userId === entity.id)
      return false;

    switch (roles[0].toLowerCase()) {
      case 'fabricator.admin': // Licensed Admin, only employees
        return !entity.isFabricatorMaster && !entity.isLicensedAdmin;
      case 'fabricator.user': // Employee
        return false;
      case 'fabricator.master': // Master Fabricator
        return !entity.isFabricatorMaster;
    }

    return true;
  }

  render = template;
}

Employees.propTypes = {
  employees: PropTypes.array,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  success: PropTypes.bool,
  getEmployees: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const EmployeesLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(EmployeesHeader),
  content: injectIntl(connector(Employees))
});

